const Store = {
    es_ES: 1,
    fr_FR: 2,
    it_IT: 3,
    da_DK: 4,
    pl_PL: 5,
    nl_NL: 6,
    pt_PT: 7,
    de_DE: 8,
    en_GB: 9,
};

const Country = {
    es_ES: 'ES',
    fr_FR: 'FR',
    it_IT: 'IT',
    da_DK: 'DK',
    pl_PL: 'PL',
    nl_NL: 'NL',
    pt_PT: 'PT',
    de_DE: 'DE',
    en_GB: 'GB',
};

const StoreUuid = {
    es_ES: '7f54c5be-e378-465d-8a7a-4017c409602d',
    fr_FR: '34060f2a-5c68-41e6-b392-94cac667b659',
    it_IT: 'f758bbb0-fb6a-46d9-aeb4-96c0e2354de2',
    da_DK: 'f78b76e4-fa2c-4875-b169-d0037243cae0',
    pl_PL: '00e8bce2-f0a1-4fe5-9d1b-2a073f767271',
    nl_NL: 'fb3b246e-cede-4a2f-85ad-a4643ac2047a',
    pt_PT: '9ca7f88c-f5db-4b93-9939-a660c421cb4a',
    de_DE: '34eeecf5-c515-4e4a-966b-ec16a1c6768c',
    en_GB: '65863f50-9475-4404-a5aa-d1a0067dedd8',
};

// TODO: deprecated -- use StoreUuid instead
const CountryUuid = StoreUuid;

const Lang = {
    es_ES: 'es',
    fr_FR: 'fr',
    it_IT: 'it',
    da_DK: 'da',
    pl_PL: 'pl',
    nl_NL: 'nl',
    pt_PT: 'pt',
    de_DE: 'de',
    en_GB: 'en',
};

const Extension = {
    es_ES: '.com',
    fr_FR: '.fr',
    it_IT: '.it',
    da_DK: '.dk',
    pl_PL: '.pl',
    nl_NL: '.nl',
    pt_PT: '.pt',
    de_DE: '.de',
    en_GB: '.net',
};

const StoreFullName = {
    es_ES: 'Español',
    fr_FR: 'Français',
    it_IT: 'Italiano',
    da_DK: 'Dansk',
    pl_PL: 'Polski',
    nl_NL: 'Nederlands',
    pt_PT: 'Português',
    de_DE: 'Deutsch',
    en_GB: 'English',
};

const StoreDeliveryThreshold = {
    es_ES: 49,
    fr_FR: 60,
    it_IT: 80,
    da_DK: null,
    pl_PL: null,
    nl_NL: null,
    pt_PT: null,
    de_DE: 70,
    en_GB: null,
};

const getLangs = () => Object.values(Lang);
const getLangByStoreId = (store) => Lang[Object.keys(Store).find((k) => Store[k] === store)];
const getStore = (locale) => Store[locale];
const getStoreUuid = (locale) => StoreUuid[locale];
const getExtension = (locale) => Extension[locale];
const getCountry = (locale) => Country[locale];
const getCountryByLang = (lang) => Country[getLocaleByLang(lang)];
const getLocaleByLang = (lang) => Object.keys(Lang).find((k) => Lang[k] === lang);
const isValidCountry = (country) => /^[a-zA-Z]{2}$/.test(country);
const isValidLang = (lang) => Object.values(Lang).indexOf(lang) > -1;
const getLangByExt = (ext) => Lang[Object.keys(Extension).find((k) => Extension[k] === `.${ext}`)];

// TODO: deprecated -- use getStoreUuid instead
const getCountryUuidBylang = (lang) => CountryUuid[getLocaleByLang(lang)];

const getStores = (url) => Object.keys(Store).map((locale) => ({
    lang: Lang[locale],
    flag: Country[locale].toLowerCase(),
    name: StoreFullName[locale],
    url: getDomain(url, locale),
}));

const getDomain = (url, locale) => url
    .replace(/^[a-z]{2}\.(.*\.tech)$/, `https://${ Lang[locale] }.$1`)
    .replace(/^([a-z.]*)\.[a-z]{2,4}$/, `https://$1${ Extension[locale] }`);

const Utils = {
    getLocaleByLang,
    getLangByStoreId,
    getStore,
    getCountry,
    getCountryByLang,
    getCountryUuidBylang,
    getStoreUuid,
    isValidCountry,
    isValidLang,
    getStores,
    getExtension,
    getLangs,
    getLangByExt,
};

export default Utils;

export {
    Country,
    StoreDeliveryThreshold,
    Lang,
    Extension,
    StoreUuid,
};
